import { ShieldCheck, Award, Phone } from "lucide-react";
import threeMLogo from "@/assets/3m-logo.png.asset.json";

/**
 * Ljus, smal trust-rad högst upp på sidan — lättar visuellt över navet
 * och visar officiell 3M-wordmark + trust-signaler. Endast desktop.
 */
export function TopTrustBar() {
  return (
    <div className="hidden md:block fixed top-0 inset-x-0 z-[70] bg-cream text-navy border-b border-navy/10 shadow-[0_1px_0_rgba(0,0,0,0.04)]">
      <div className="mx-auto max-w-7xl px-5 md:px-10 h-9 flex items-center justify-between gap-6">
        {/* 3M wordmark + auktorisation */}
        <div className="flex items-center gap-3">
          <img
            src={threeMLogo.url}
            alt="3M"
            width={120}
            height={64}
            decoding="async"
            className="h-4 w-auto"
          />
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] font-bold text-navy">
            Auktoriserad installatör <span className="text-gold-bright">·</span>{" "}
            <span className="text-navy/70">sedan 2008</span>
          </span>
        </div>


        {/* Trust badges */}
        <div className="flex items-center gap-6 text-[10px] font-mono uppercase tracking-[0.2em] text-navy/75">
          <span className="hidden lg:inline-flex items-center gap-1.5">
            <ShieldCheck size={12} className="text-gold-bright" /> 10 års garanti
          </span>
          <span className="hidden lg:inline-flex items-center gap-1.5">
            <Award size={12} className="text-gold-bright" /> 3 500+ kunder
          </span>
          <a
            href="tel:+46771502502"
            className="inline-flex items-center gap-1.5 hover:text-gold-bright transition-colors"
          >
            <Phone size={12} className="text-gold-bright" />
            <span className="font-semibold">0771 502 502</span>
          </a>
        </div>
      </div>
    </div>
  );
}
